import { HttpContextToken } from '@angular/common/http';

/**
 * Marks whether a request needs to automatically set the x-locales header
 * Used for Portal API requests that require multi-language support
 */
export const NEEDS_X_LOCALES = new HttpContextToken<boolean>(() => false);

/**
 * Identifies the entity type of the request caller, used for interceptors to determine whether to apply certain logic, such as translating response items based on user language
 */
export const REQUEST_CALLER_IDENTIFY = new HttpContextToken<string>(() => null);
